import { render, staticRenderFns } from "./splitshift.vue?vue&type=template&id=4a3ceae7&scoped=true&lang=pug"
import script from "./splitshift.vue?vue&type=script&lang=js"
export * from "./splitshift.vue?vue&type=script&lang=js"
import style0 from "./splitshift.vue?vue&type=style&index=0&id=4a3ceae7&prod&lang=scss"
import style1 from "./splitshift.vue?vue&type=style&index=1&id=4a3ceae7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3ceae7",
  null
  
)

export default component.exports